import router from './routes'
import store from './store'

// 提取存储，优先组件执行
const role = JSON.parse(window.sessionStorage.getItem('role'))
if (role) {
  new Promise((resolve, reject) => {
    store.dispatch('permission/generateRoutes', role.length > 0 ? ['cmpp'] : ['http']).then((accessRoutes) => {
      router.addRoutes(accessRoutes)
      resolve('reset')
    })
  })
}



// WEBPACK FOOTER //
// ./src/permission.js